import { z } from 'zod';
import { tagSchema } from './reception.js';
export const LEAD_STAGES = ['new', 'qualifying', 'evaluation_scheduled', 'evaluated', 'quoted', 'won', 'lost'];
export const OPEN_STAGES = ['new', 'qualifying', 'evaluation_scheduled', 'evaluated', 'quoted'];
export const LOST_REASONS = ['price', 'no_response', 'not_candidate', 'competitor', 'timing', 'other'];
export const LEAD_SOURCES = ['whatsapp', 'meta_ads', 'google_ads', 'instagram', 'site', 'referral', 'walk_in', 'phone', 'other'];
export const PROCEDURE_AREAS = ['scalp', 'eyebrow', 'beard', 'other'];
export const leadCardSchema = z.object({
    id: z.uuid(),
    contact: z.object({ id: z.uuid(), name: z.string(), maskedPhone: z.string().nullable() }),
    stage: z.enum(LEAD_STAGES),
    lostReason: z.enum(LOST_REASONS).nullable(),
    source: z.enum(LEAD_SOURCES),
    campaign: z.string().nullable(),
    procedureArea: z.enum(PROCEDURE_AREAS).nullable(),
    assignedTo: z.object({ id: z.uuid(), name: z.string() }).nullable(),
    stageChangedAt: z.string(),
    createdAt: z.string(),
    /** Conversa aberta no WhatsApp com a pessoa, se houver. */
    conversationId: z.uuid().nullable(),
    lastMessageAt: z.string().nullable(),
    version: z.number().int(),
    /** Etiquetas do contato (acompanham a pessoa em todos os leads). */
    tags: z.array(tagSchema),
});
export const leadBoardSchema = z.object({
    columns: z.array(z.object({ stage: z.enum(LEAD_STAGES), total: z.number().int(), leads: z.array(leadCardSchema) })),
});
export const leadEventSchema = z.object({
    id: z.uuid(),
    type: z.enum(['created', 'stage_changed', 'assigned', 'updated', 'note']),
    fromStage: z.enum(LEAD_STAGES).nullable(),
    toStage: z.enum(LEAD_STAGES).nullable(),
    actorName: z.string().nullable(),
    actorType: z.enum(['user', 'system', 'ai_agent']),
    data: z.record(z.string(), z.unknown()),
    note: z.string().nullable(),
    createdAt: z.string(),
});
export const leadDetailSchema = leadCardSchema.extend({ events: z.array(leadEventSchema) });
export const createLeadSchema = z.object({
    name: z.string().trim().min(2, 'Informe o nome').max(80),
    phone: z.string().min(8, 'Informe o celular com DDD').max(25),
    source: z.enum(LEAD_SOURCES),
    procedureArea: z.enum(PROCEDURE_AREAS).nullable().optional(),
    note: z.string().trim().max(2000).optional(),
});
export const moveLeadSchema = z.object({
    stage: z.enum(LEAD_STAGES),
    lostReason: z.enum(LOST_REASONS).optional(),
    note: z.string().trim().max(2000).optional(),
    /** Concorrência otimista: recusa se outra pessoa mexeu no lead enquanto isso. */
    version: z.number().int(),
}).refine((v) => v.stage !== 'lost' || !!v.lostReason, { message: 'Informe o motivo da perda', path: ['lostReason'] });
export const updateLeadSchema = z.object({
    procedureArea: z.enum(PROCEDURE_AREAS).nullable().optional(),
    source: z.enum(LEAD_SOURCES).optional(),
    assignedUserId: z.uuid().nullable().optional(),
});
export const addNoteSchema = z.object({ text: z.string().trim().min(1, 'Escreva a nota').max(2000) });
export const assignableUserSchema = z.object({ id: z.uuid(), name: z.string() });
//# sourceMappingURL=crm.js.map